module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "citic-table-list"
  }, [(_vm.status === 'pending') ? _c('el-tabs', {
    on: {
      "tab-click": _vm.handleClick
    },
    model: {
      value: (_vm.activeName),
      callback: function($$v) {
        _vm.activeName = $$v
      },
      expression: "activeName"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "待处理",
      "name": "0"
    }
  }, [(_vm.status === 'pending') ? _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    ref: "dataTable",
    staticClass: "post_table",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.lists_unbsae,
      "height": "600"
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "width": "30"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "点评时间",
      "width": "180"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n            " + _vm._s(_vm._f("datetime")(scope.row.time_created / 1000)) + "\n          ")]
      }
    }], null, false, 868237377)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "productname",
      "label": "产品名称",
      "width": "180"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "新增产品"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticStyle: {
            "margin-left": "10px"
          }
        }, [_vm._v(_vm._s(_vm._f("boolMapper")(scope.row.has_new_product)))])]
      }
    }], null, false, 1016905157)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "新增类别"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticStyle: {
            "margin-left": "10px"
          }
        }, [_vm._v(_vm._s(_vm._f("boolMapper")(scope.row.has_new_category)))])]
      }
    }], null, false, 1996437918)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "新增厂商简称"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticStyle: {
            "margin-left": "10px"
          }
        }, [_vm._v(_vm._s(_vm._f("boolMapper")(scope.row.has_new_company_alias)))])]
      }
    }], null, false, 4114723392)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "新增产品-类别关系"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticStyle: {
            "margin-left": "10px"
          }
        }, [_vm._v(_vm._s(_vm._f("boolMapper")(scope.row.has_new_category_product_relation)))])]
      }
    }], null, false, 1670830867)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "align": "center",
      "width": "150"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "small",
            "type": "primary"
          },
          on: {
            "click": function($event) {
              $event.preventDefault();
              $event.stopPropagation();
              return _vm.handleEngage(scope.row)
            }
          }
        }, [_vm._v("马上处理")])]
      }
    }], null, false, 4278046486)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "状态",
      "align": "center",
      "width": "150"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "small",
            "type": "primary"
          },
          on: {
            "click": function($event) {
              return _vm.handleIsprocessed(scope.row)
            }
          }
        }, [_vm._v("忽略")])]
      }
    }], null, false, 1621803598)
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "table-list__footer"
  }, [_c('el-pagination', {
    attrs: {
      "current-page": _vm.page,
      "page-size": _vm.pageSizeOne,
      "layout": "total, prev, pager, next, jumper",
      "total": _vm.totalOne
    },
    on: {
      "current-change": _vm.handlePageChange
    }
  })], 1)], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "已忽略",
      "name": "1"
    }
  }, [(_vm.status === 'pending') ? _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    ref: "dataTable",
    staticClass: "post_table",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.lists_base,
      "height": "600"
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "width": "30"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "点评时间",
      "width": "180"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n            " + _vm._s(_vm._f("datetime")(scope.row.time_created / 1000)) + "\n          ")]
      }
    }], null, false, 868237377)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "productname",
      "label": "产品名称",
      "width": "180"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "新增产品"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticStyle: {
            "margin-left": "10px"
          }
        }, [_vm._v(_vm._s(_vm._f("boolMapper")(scope.row.has_new_product)))])]
      }
    }], null, false, 1016905157)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "新增类别"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticStyle: {
            "margin-left": "10px"
          }
        }, [_vm._v(_vm._s(_vm._f("boolMapper")(scope.row.has_new_category)))])]
      }
    }], null, false, 1996437918)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "新增厂商简称"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticStyle: {
            "margin-left": "10px"
          }
        }, [_vm._v(_vm._s(_vm._f("boolMapper")(scope.row.has_new_company_alias)))])]
      }
    }], null, false, 4114723392)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "新增产品-类别关系"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticStyle: {
            "margin-left": "10px"
          }
        }, [_vm._v(_vm._s(_vm._f("boolMapper")(scope.row.has_new_category_product_relation)))])]
      }
    }], null, false, 1670830867)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "align": "center",
      "width": "150"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "small",
            "type": "primary"
          },
          on: {
            "click": function($event) {
              $event.preventDefault();
              $event.stopPropagation();
              return _vm.handleEngage(scope.row)
            }
          }
        }, [_vm._v("马上处理")])]
      }
    }], null, false, 4278046486)
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "table-list__footer"
  }, [_c('el-pagination', {
    attrs: {
      "current-page": _vm.page,
      "page-size": _vm.pageSizeTwo,
      "layout": "total, prev, pager, next, jumper",
      "total": _vm.totalTwo
    },
    on: {
      "current-change": _vm.handlePageChange
    }
  })], 1)], 1)], 1) : (_vm.status === 'stored') ? _c('el-tabs', {
    on: {
      "tab-click": _vm.handleClick
    },
    model: {
      value: (_vm.activeName),
      callback: function($$v) {
        _vm.activeName = $$v
      },
      expression: "activeName"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "待审核",
      "name": "0"
    }
  }, [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    ref: "dataTable",
    staticClass: "post_table",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.lists_unreviews,
      "height": "600"
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "width": "30"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "点评时间",
      "width": "180"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n            " + _vm._s(_vm._f("datetime")(scope.row.time_created / 1000)) + "\n          ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "productname",
      "label": "产品名称",
      "width": "180"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "类别"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticStyle: {
            "margin-left": "10px"
          }
        }, [_vm._v(_vm._s(scope.row.categoryname))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "厂商简称"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticStyle: {
            "margin-left": "10px"
          }
        }, [_vm._v(_vm._s(scope.row.factoryname))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "口碑指数"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticStyle: {
            "margin-left": "10px"
          }
        }, [_vm._v(_vm._s(scope.row.score))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "优点"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticStyle: {
            "margin-left": "10px"
          }
        }, [_vm._v(_vm._s(scope.row.pros))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "align": "center",
      "width": "150"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "small",
            "type": "primary"
          },
          on: {
            "click": function($event) {
              $event.preventDefault();
              $event.stopPropagation();
              return _vm.handleUpdate(scope.row)
            }
          }
        }, [_vm._v("马上审核")])]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "table-list__footer"
  }, [_c('el-pagination', {
    attrs: {
      "current-page": _vm.page,
      "page-size": _vm.pageSizeThree,
      "layout": "total, prev, pager, next, jumper",
      "total": _vm.totalThree
    },
    on: {
      "current-change": _vm.handlePageChange
    }
  })], 1)], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "已审核",
      "name": "1"
    }
  }, [_c('el-select', {
    staticStyle: {
      "margin-top": "20px",
      "margin-bottom": "20px"
    },
    attrs: {
      "placeholder": "请选择"
    },
    on: {
      "change": _vm.handleReviewStatusChange
    },
    model: {
      value: (_vm.reviewStatus),
      callback: function($$v) {
        _vm.reviewStatus = $$v
      },
      expression: "reviewStatus"
    }
  }, _vm._l((_vm.options), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    ref: "dataTable",
    staticClass: "post_table",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.lists_reviews,
      "height": "600"
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "width": "30"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "点评时间",
      "width": "180"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n            " + _vm._s(_vm._f("datetime")(scope.row.time_created / 1000)) + "\n          ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "productname",
      "label": "产品名称",
      "width": "180"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "类别"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticStyle: {
            "margin-left": "10px"
          }
        }, [_vm._v(_vm._s(scope.row.categoryname))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "厂商简称"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticStyle: {
            "margin-left": "10px"
          }
        }, [_vm._v(_vm._s(scope.row.factoryname))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "口碑指数"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticStyle: {
            "margin-left": "10px"
          }
        }, [_vm._v(_vm._s(scope.row.score))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "优点"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticStyle: {
            "margin-left": "10px"
          }
        }, [_vm._v(_vm._s(scope.row.pros))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "点评打钱",
      "align": "center",
      "width": "150"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.ismakemoney === '1') ? _c('el-button', {
          attrs: {
            "size": "small",
            "type": "primary",
            "disabled": ""
          },
          on: {
            "click": function($event) {
              $event.preventDefault();
              $event.stopPropagation();
              return _vm.handleMoney(scope.row)
            }
          }
        }, [_vm._v("已打钱")]) : _vm._e(), _vm._v(" "), (scope.row.ismakemoney === '0') ? _c('el-button', {
          attrs: {
            "size": "small",
            "type": "primary"
          },
          on: {
            "click": function($event) {
              $event.preventDefault();
              $event.stopPropagation();
              return _vm.handleMoney(scope.row)
            }
          }
        }, [_vm._v("打钱")]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "align": "center",
      "width": "150"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "small",
            "type": "primary"
          },
          on: {
            "click": function($event) {
              $event.preventDefault();
              $event.stopPropagation();
              return _vm.handleUpdate(scope.row)
            }
          }
        }, [_vm._v("马上处理")])]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "table-list__footer"
  }, [_c('el-pagination', {
    attrs: {
      "current-page": _vm.page,
      "page-size": _vm.pageSizeFour,
      "layout": "total, prev, pager, next, jumper",
      "total": _vm.totalFour
    },
    on: {
      "current-change": _vm.handlePageChange
    }
  })], 1)], 1)], 1) : _c('el-tabs', {
    on: {
      "tab-click": _vm.handleClick
    },
    model: {
      value: (_vm.activeName),
      callback: function($$v) {
        _vm.activeName = $$v
      },
      expression: "activeName"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "待处理",
      "name": "0"
    }
  }, [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    ref: "dataTable",
    staticClass: "post_table",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.lists_unsmart,
      "height": "600"
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "width": "30"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "点评时间",
      "width": "180"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n            " + _vm._s(_vm._f("datetime")(scope.row.time_created / 1000)) + "\n          ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "productname",
      "label": "产品名称",
      "width": "180"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "类别"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticStyle: {
            "margin-left": "10px"
          }
        }, [_vm._v(_vm._s(scope.row.categoryname))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "厂商简称"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticStyle: {
            "margin-left": "10px"
          }
        }, [_vm._v(_vm._s(scope.row.factoryname))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "口碑指数"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticStyle: {
            "margin-left": "10px"
          }
        }, [_vm._v(_vm._s(scope.row.ztgsnum))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "优点"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticStyle: {
            "margin-left": "10px"
          }
        }, [_vm._v(_vm._s(scope.row.advantages))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "align": "center",
      "width": "150"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "small",
            "type": "primary"
          },
          on: {
            "click": function($event) {
              $event.preventDefault();
              $event.stopPropagation();
              return _vm.hendleSmart(scope.row)
            }
          }
        }, [_vm._v("马上处理")])]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "table-list__footer"
  }, [_c('el-pagination', {
    attrs: {
      "current-page": _vm.page,
      "page-size": _vm.pageSizeFive,
      "layout": "total, prev, pager, next, jumper",
      "total": _vm.totalFive
    },
    on: {
      "current-change": _vm.handlePageChange
    }
  })], 1)], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "已处理",
      "name": "1"
    }
  }, [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    ref: "dataTable",
    staticClass: "post_table",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.lists_smart,
      "height": "600"
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "width": "30"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "点评时间",
      "width": "180"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n            " + _vm._s(_vm._f("datetime")(scope.row.time_created / 1000)) + "\n          ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "productname",
      "label": "产品名称",
      "width": "180"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "类别"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticStyle: {
            "margin-left": "10px"
          }
        }, [_vm._v(_vm._s(scope.row.categoryname))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "厂商简称"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticStyle: {
            "margin-left": "10px"
          }
        }, [_vm._v(_vm._s(scope.row.factoryname))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "口碑指数"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticStyle: {
            "margin-left": "10px"
          }
        }, [_vm._v(_vm._s(scope.row.ztgsnum))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "优点"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticStyle: {
            "margin-left": "10px"
          }
        }, [_vm._v(_vm._s(scope.row.advantages))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "align": "center",
      "width": "150"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "small",
            "type": "primary"
          },
          on: {
            "click": function($event) {
              $event.preventDefault();
              $event.stopPropagation();
              return _vm.hendleSmart(scope.row)
            }
          }
        }, [_vm._v("马上处理")])]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "table-list__footer"
  }, [_c('el-pagination', {
    attrs: {
      "current-page": _vm.page,
      "page-size": _vm.pageSizeSix,
      "layout": "total, prev, pager, next, jumper",
      "total": _vm.totalSix
    },
    on: {
      "current-change": _vm.handlePageChange
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('TheSlideBox', {
    attrs: {
      "name": "reivew-detail-panel",
      "visible": _vm.shouldShowDetailPanel
    },
    on: {
      "close": _vm.closeDetailPanel
    }
  }, [(_vm.status === 'pending' && _vm.shouldShowDetailPanel) ? _c('detail', {
    attrs: {
      "reviewId": _vm.currentReviewId,
      "reviewStatus": _vm.currentReviewStatus
    },
    on: {
      "statusUpdate": _vm.handleReviewStatusUpdate,
      "finished": _vm.handleFinished
    }
  }) : _vm._e(), _vm._v(" "), (_vm.status === 'stored' && _vm.shouldShowDetailPanel) ? _c('edit', {
    attrs: {
      "reviewId": _vm.currentReviewId
    }
  }) : _vm._e(), _vm._v(" "), (_vm.status === 'analysis' && _vm.shouldShowDetailPanel) ? _c('smart', {
    attrs: {
      "reviewId": _vm.currentReviewId,
      "categoryId": _vm.currentCategoryId
    }
  }) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@9.9.5@vue-loader/lib/template-compiler.js?id=data-v-41704179!./~/_vue-loader@9.9.5@vue-loader/lib/selector.js?type=template&index=0!./src/components/modules/posts/List.vue
// module id = 453
// module chunks = 11